import { render, staticRenderFns } from "./SearchColumn.vue?vue&type=template&id=5123aaa6&scoped=true&"
import script from "./SearchColumn.vue?vue&type=script&lang=js&"
export * from "./SearchColumn.vue?vue&type=script&lang=js&"
import style0 from "./SearchColumn.vue?vue&type=style&index=0&id=5123aaa6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5123aaa6",
  null
  
)

export default component.exports